// Tiny shared formatters. No date-fns/dayjs — keep deps tight.

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const diffMs = Date.now() - then;
  const future = diffMs < 0;
  const abs = Math.abs(diffMs);
  const sec = Math.round(abs / 1000);
  const min = Math.round(sec / 60);
  const hr = Math.round(min / 60);
  const day = Math.round(hr / 24);
  let out: string;
  if (sec < 60) out = `${sec}s`;
  else if (min < 60) out = `${min}m`;
  else if (hr < 24) out = `${hr}h`;
  else out = `${day}d`;
  return future ? `in ${out}` : `${out} ago`;
}

export function clockTime(date = new Date()): string {
  return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function longDate(date = new Date()): string {
  return date.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
}

export function healthColor(h: "green" | "yellow" | "red" | string | null | undefined): string {
  if (h === "green") return "var(--green)";
  if (h === "yellow") return "var(--amber)";
  if (h === "red") return "var(--crimson)";
  return "var(--text-quiet)";
}

export function healthFill(h: "green" | "yellow" | "red" | string | null | undefined): number {
  if (h === "green") return 95;
  if (h === "yellow") return 65;
  if (h === "red") return 35;
  return 50;
}
